module.exports = __webpack_public_path__ + "img/15.9c2cdd8c.jpg";